import React from 'react';

function CompliancePage() {
  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">Compliance</h1>
        <p className="text-gray-600">KYC verification and compliance monitoring</p>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <p className="text-gray-500">Compliance management coming soon...</p>
      </div>
    </div>
  );
}

export default CompliancePage;
